<template>
  <div>
    <a-modal v-model="visible" :title="getTitle" width="1200px" centered :ok-button-props="{ props: { loading: loading } }" class="problem-modal" @cancel="visible = false" @ok="onSubmit">
      <a-spin :spinning="spinning">
        <a-form-model ref="form" :model="form" :rules="rules" class="problem-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <div class="problem-form__main">
            <div class="problem-form__left">
              <a-form-model-item label="标题" prop="title" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                <a-input v-model="form.title" placeholder="请输入问题标题" />
              </a-form-model-item>
              <a-form-model-item label="描述" prop="content" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                <vditor-editor :key="editorKey" v-model="form.content" :height="500" />
              </a-form-model-item>
              <a-form-model-item label="总结" prop="summary" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                <a-textarea v-model="form.summary" placeholder="用一句话来总结" :auto-size="{ minRows: 3, maxRows: 5 }" />
              </a-form-model-item>
            </div>
            <div class="problem-form__right">
              <div class="problem-form__section">
                <h3 class="problem-form__section-title">基本信息</h3>
                <a-form-model-item label="问题类型" prop="problem_type">
                  <a-select v-model="form.problem_type" allow-clear placeholder="请选择问题类型" show-search :filter-option="utils.filterOption">
                    <a-select-option v-for="(item, key) in problemTypes" :key="key" :value="item.value">{{ item.label }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="关联项目" prop="projects">
                  <a-select v-model="form.projects" mode="multiple" show-search placeholder="请选择关联项目" :filter-option="utils.filterOption">
                    <a-select-option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="紧急程度" prop="urgency">
                  <a-select v-model="form.urgency" placeholder="请选择紧急程度">
                    <a-select-option v-for="(item, key) in problemUrgencys" :key="key" :value="item.value">
                      <a-tag :color="item.color">{{ item.label }}</a-tag>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>

              <div class="problem-form__section">
                <h3 class="problem-form__section-title">处理信息</h3>
                <a-form-model-item label="处理人" prop="handler">
                  <a-select v-model="form.handler" allow-clear placeholder="请选择处理人" show-search :filter-option="utils.filterOption">
                    <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="反馈人" prop="reporter">
                  <a-select v-model="form.reporter" allow-clear placeholder="请选择反馈人" show-search :filter-option="utils.filterOption">
                    <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="反馈渠道" prop="channel">
                  <a-select v-model="form.channel" allow-clear placeholder="请选择反馈渠道" show-search>
                    <a-select-option v-for="(item, key) in problemChannels" :key="key" :value="item.value">{{ item.label }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="出现频率" prop="frequency">
                  <a-select v-model="form.frequency" allow-clear placeholder="请选择出现频率" show-search :filter-option="utils.filterOption">
                    <a-select-option v-for="(item, key) in problemFrequencys" :key="key" :value="item.value">{{ item.label }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>

              <div class="problem-form__section">
                <h3 class="problem-form__section-title">时间信息</h3>
                <a-form-model-item label="开始时间" prop="started_time">
                  <a-date-picker v-model="form.started_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
                </a-form-model-item>
                <a-form-model-item label="发现时间" prop="discovered_time">
                  <a-date-picker v-model="form.discovered_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
                </a-form-model-item>
                <a-form-model-item label="上报时间" prop="reported_time">
                  <a-date-picker v-model="form.reported_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
                </a-form-model-item>
                <a-form-model-item label="定位时间" prop="located_time">
                  <a-date-picker v-model="form.located_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
                </a-form-model-item>
                <a-form-model-item label="解决时间" prop="resolved_time">
                  <a-date-picker v-model="form.resolved_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
                </a-form-model-item>
                <a-form-model-item label="业务确认时间" prop="confirmed_time">
                  <a-date-picker v-model="form.confirmed_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
                </a-form-model-item>
              </div>
            </div>
          </div>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { projectList } from '@/api/project/project';
import { problemDetail, problemAdd, problemModify } from '@/api/event/problem';
import { problemUrgencys, problemChannels, problemFrequencys, problemTypes } from '@/utils/dictionary';
import VditorEditor from '@/components/VditorEditor';
import { userList } from '@/api/system/auth';

export default {
  name: 'ProblemModal',
  components: { VditorEditor },
  data() {
    return {
      problemTypes,
      problemUrgencys,
      problemChannels,
      problemFrequencys,
      spinning: false,
      loading: false,
      visible: false,
      projects: [],
      problemId: null,
      problemFileList: [],
      form: {
        title: null
      },
      userData: [],
      editorKey: null,
      rules: {
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '描述内容不能为空', trigger: 'blur' }],
        projects: [{ required: true, message: '关联项目不能为空', trigger: 'blur' }],
        problem_type: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
        urgency: [{ required: true, message: '紧急程度不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    getTitle() {
      return `${this.problemId === null ? '添加' : '编辑'}问题`;
    }
  },
  methods: {
    // 打开添加问题弹窗
    openAdd() {
      this.problemId = null;
      this.visible = true;
      this.editorKey = Date.now();
      // 重置表单数据
      this.form = {
        title: null,
        content: '',
        summary: null,
        channel: undefined,
        urgency: undefined,
        problem_type: undefined,
        frequency: undefined,
        handler: null,
        reporter: null,
        projects: [],
        reported_time: null,
        started_time: null,
        resolved_time: null,
        located_time: null,
        discovered_time: null,
        confirmed_time: null
      };
      this.getProjectList();
      this.getUserList();
    },

    // 打开编辑问题弹窗
    openEdit(id) {
      this.problemId = id;
      this.visible = true;
      this.editorKey = Date.now();
      this.getProblemDetail();
      this.getProjectList();
      this.getUserList();
    },

    closed() {
      this.visible = false;
      this.loading = false;
      this.form = {
        title: null,
        content: '',
        summary: null,
        channel: undefined,
        urgency: undefined,
        problem_type: undefined,
        frequency: undefined,
        handler: null,
        reporter: null,
        projects: [],
        reported_time: null,
        started_time: null,
        resolved_time: null,
        located_time: null,
        discovered_time: null,
        confirmed_time: null
      };
      this.$emit('close');
    },

    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
      });
    },

    // 获取用户列表
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users;
      });
    },

    // 获取问题详情
    getProblemDetail() {
      this.spinning = true;
      problemDetail({ id: this.problemId }).then(res => {
        const data = res.data;
        this.form = {
          title: data.title,
          channel: data.channel || undefined,
          urgency: data.urgency || undefined,
          problem_type: data.problem_type || undefined,
          frequency: data.frequency || undefined,
          handler: data.handler ? data.handler.id : null,
          reporter: data.reporter ? data.reporter.id : null,
          projects: data.projects.map(p => p.id),
          reported_time: data.reported_time,
          started_time: data.started_time,
          resolved_time: data.resolved_time,
          content: data.content || '',
          summary: data.summary,
          located_time: data.located_time,
          discovered_time: data.discovered_time,
          confirmed_time: data.confirmed_time
        };
        this.spinning = false;
        // 确保编辑器能够正确显示内容
        this.$nextTick(() => {
          this.editorKey = Date.now();
        });
      });
    },

    // 点击提交
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.problemId === null) {
            // 添加问题
            problemAdd(this.form)
              .then(() => {
                this.closed();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            // 编辑问题
            problemModify({ id: this.problemId, ...this.form })
              .then(() => {
                this.closed();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.problem-modal {
  :deep(.ant-modal-body) {
    padding: 16px;
  }
}

.problem-form {
  &__main {
    display: flex;
    gap: 12px;
  }

  &__left {
    flex: 1;
    min-width: 0;
  }

  &__right {
    width: 360px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    :deep(.ant-form-item-label) {
      label {
        font-size: 12px;
      }
    }
  }

  &__section {
    background: #fafafa;
    border-radius: 2px;
    padding: 8px;

    &-title {
      font-size: 12px;
      font-weight: 500;
      color: #262626;
      margin-bottom: 8px;
      padding-left: 4px;
      border-left: 2px solid #1890ff;
    }
  }

  :deep(.ant-form-item) {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    .ant-form-item-label {
      line-height: 32px;
      padding-bottom: 0;
      text-align: right;
    }

    .ant-form-item-control {
      line-height: 32px;
    }
  }

  :deep(.ant-select),
  :deep(.ant-picker) {
    width: 100%;
  }
}
</style>
